'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import unescapedText from 'I18n/utils/unescapedText';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISearchInput from 'UIComponents/input/UISearchInput';
import Checkbox from '../inputs/Checkbox';
import ExpandableFilter from './ExpandableFilter';

const IntegrationsToggleGroup = ({
  appIntegrations,
  expandable = true,
  onChange,
  trackInteraction,
  value
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTracked, setSearchTracked] = useState(false);
  const trackSearch = useCallback(() => {
    if (!searchTracked) {
      trackInteraction('search app integrations');
      setSearchTracked(true);
    }
  }, [searchTracked, trackInteraction]);
  const handleChange = useCallback(({
    target: {
      checked,
      value: inputValue
    }
  }) => {
    onChange(checked ? value.add(inputValue) : value.delete(inputValue));
  }, [onChange, value]);
  const renderedInputs = useMemo(() => {
    return appIntegrations.filter(integration => {
      if (searchTerm) {
        const searchRegex = new RegExp(searchTerm, 'i');
        return searchRegex.test(integration);
      }

      return true;
    }).map(integration => /*#__PURE__*/_jsx(Checkbox, {
      checked: value.includes(integration),
      onChange: handleChange,
      value: integration,
      children: integration
    }, integration));
  }, [appIntegrations, handleChange, searchTerm, value]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": "integrations",
      children: /*#__PURE__*/_jsx(UISearchInput, {
        onBlur: () => {
          setSearchTracked(false);
        },
        onChange: ({
          target: {
            value: searchValue
          }
        }) => {
          if (searchValue.trim()) {
            setSearchTerm(searchValue);
            trackSearch();
          } else {
            setSearchTerm('');
          }
        },
        placeholder: unescapedText('appMarketplace.storefront.filters.integrations.searchInputPlaceholder')
      })
    }), expandable ? /*#__PURE__*/_jsx(ExpandableFilter, {
      name: "integrations",
      children: renderedInputs
    }) : renderedInputs]
  });
};

IntegrationsToggleGroup.propTypes = {
  appIntegrations: ImmutablePropTypes.orderedSet.isRequired,
  expandable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  trackInteraction: PropTypes.func.isRequired,
  value: ImmutablePropTypes.iterableOf(PropTypes.string).isRequired
};
export default IntegrationsToggleGroup;